var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"software-page"},[_c('section',{staticClass:"banner-section"},[_c('div',{staticClass:"banner-content"},[_c('h1',{staticClass:"banner-title"},[_vm._v("软件")])])]),_c('section',{staticClass:"content-section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"software-intro"},[_c('h2',[_vm._v("软件介绍")]),_c('p',[_vm._v("这里是软件页面内容。")])])])])])
}]

export { render, staticRenderFns }